export const formatINR = (amount) => {
  if (amount == null) return "";
  return "₹" + Number(amount).toLocaleString("en-IN");
};

const IST = "Asia/Kolkata";

export const formatDate = (iso, opts) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "numeric", month: "long", year: "numeric", timeZone: IST, ...opts,
    });
  } catch { return iso; }
};

export const formatDateShort = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric", month: "short", timeZone: IST,
  });
};

export const formatTimeIST = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-IN", {
    hour: "2-digit", minute: "2-digit", timeZone: IST, hour12: true,
  });
};

export const formatDateTimeIST = (iso) => {
  if (!iso) return "";
  return `${formatDate(iso)} · ${formatTimeIST(iso)} IST`;
};

export const localTz = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
